import { ITaskModel } from './../../../../../shared/interfaces/task-model.interface';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { navigateTo } from 'src/app/shared/utils/utils';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-show-task-tab-button',
    templateUrl: './show-task-tab-button.component.html',
    styleUrls: ['./show-task-tab-button.component.scss']
})
export class ShowTaskTabButtonComponent implements OnInit {

    @Input()
    process: ITaskModel;

    constructor(
        private readonly router: Router,
    ) { }

    ngOnInit(): void {
    }

    navigateToTaskDetailsView(event: Event) {
        const url = `/instances/task/${this.process.id}`;
        const queryParams = {
            state_env: this.process.state,
        };
        navigateTo(this.router, url, queryParams);
        event.stopPropagation();
    }
}
